var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnassigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5C6.5 4.25329 10.7533 0 16 0C21.2467 0 25.5 4.25329 25.5 9.5C25.5 14.7467 21.2467 19 16 19C10.7533 19 6.5 14.7467 6.5 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 31.5C0.5 26.2533 4.75329 22 10 22H22C24.3374 22 26.4776 22.8441 28.1324 24.2442C27.1458 24.2712 26.1673 24.6612 25.4142 25.4142C23.8522 26.9763 23.8522 29.509 25.4142 31.0711L26.8285 32.4853L25.4142 33.8995C23.8522 35.4616 23.8522 37.9943 25.4142 39.5564C25.6175 39.7596 25.8373 39.9365 26.0692 40.0869C24.8358 40.6724 23.4561 41 22 41H10C4.75329 41 0.5 36.7467 0.5 31.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7886 29.3033C38.3744 28.7175 38.3744 27.7678 37.7886 27.182C37.2028 26.5962 36.2531 26.5962 35.6673 27.182L32.4853 30.364L29.3033 27.182C28.7175 26.5962 27.7678 26.5962 27.182 27.182C26.5962 27.7678 26.5962 28.7175 27.182 29.3033L30.364 32.4853L27.182 35.6673C26.5962 36.2531 26.5962 37.2028 27.182 37.7886C27.7678 38.3744 28.7175 38.3744 29.3033 37.7886L32.4853 34.6066L35.6673 37.7886C36.2531 38.3744 37.2028 38.3744 37.7886 37.7886C38.3744 37.2028 38.3744 36.2531 37.7886 35.6673L34.6066 32.4853L37.7886 29.3033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassigned);
export default __webpack_public_path__ + "static/media/unassigned.5837e1b28cae92ede54a9d4958cab6a1.svg";
export { ForwardRef as ReactComponent };